import React from 'react'
import './RecommendedVideos.css'
import VideoCard from './VideoCard'

function RecommendedVideos() {
  return (
    <div className='recommendedVideos'>
        <h2>Recommended</h2>
        <div className='recommendedVideos_videos'>
          <VideoCard
            title="Marvel Studios' Thor: Love and Thunder | Official Trailer"
            views='6.1M views'
            timestamp='3 hours ago'
            channelImage='https://yt3.ggpht.com/fGvQjp1vAT1R4bAKTFLaSbdsfdYFDwAzVjeRVQeikH22bvHWsGULZdwIkpZXktcXZc5gFJuA3w=s68-c-k-c0x00ffffff-no-rj'
            channel='Marvel Entertainment'
            image='https://i.ytimg.com/vi/Go8nTmfrQd8/hqdefault.jpg?sqp=-oaymwEcCOADEI4CSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLB_Zp22Rb6L4nN--LXsMRR6kM0gKg'
            />
            <VideoCard
            title='Coke Studio | Season 14 | Pasoori | Ali Sethi x Shae Gill'
            views='139M views'
            timestamp='3 months ago'
            channelImage='https://yt3.ggpht.com/ytc/AKedOLTNtHgVmX114S4cnjoyFaDDJE6N1zNBwKgRNnYNAg=s68-c-k-c0x00ffffff-no-rj'
            channel='Coke Studio'
            image='https://i.ytimg.com/vi/5Eqb_-j3FDA/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLCmqHUqxnAhhIsNCS7l2xBvSY6ZXA'
            />
            <VideoCard
            title='The Secret, Incredible, and Inspiring Story of Khaby'
            views='3.6M views'
            timestamp='5 days ago'
            channelImage='https://yt3.ggpht.com/ytc/AKedOLQblZ0VMGBh7XodiihT4tXmrzaX6jJNAgBiJ4F1XA=s68-c-k-c0x00ffffff-no-rj'
            channel='Nas Daily'
            image='https://i.ytimg.com/vi/F26xVfZlj6E/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBbXVUVJoADl38_S2EKOIQtp29U9g'
            />
            <VideoCard
            title='Bali in 8k ULTRA HD HDR - Paradise of Asia (60 FPS)'
            views='4.3M views'
            timestamp='3 months ago'
            channelImage='image.png'
            channel='8K World'
            image='https://i.ytimg.com/vi/BFS9n4B_2xA/hqdefault.jpg?sqp=-oaymwEcCOADEI4CSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLD6HF5DWWrUxprLaY6XiSTlZi4rJA'
            />
            <VideoCard
            title='QUICK VEGAN BREAKFAST IDEAS » bento box style'
            views='7.8M views'
            timestamp='5 years ago'
            channelImage='https://yt3.ggpht.com/ytc/AKedOLQFII48R0atMndxGz1n5quE7W1VIpMvJxNnGlUYFg=s68-c-k-c0x00ffffff-no-rj'
            channel='Pick Up Limes'
            image='https://i.ytimg.com/vi/DtZ1EjV0EEw/maxresdefault.jpg'
            />
          <VideoCard
            title="Chaos: The Science of the Butterfly Effect"
            views='5.5M views'
            timestamp='2 years ago'
            channelImage='https://yt3.ggpht.com/ytc/AKedOLQYcLqrGZC1RZL4e1AFz5-ImMQmmgObvzWBCL7-mA=s68-c-k-c0x00ffffff-no-rj'
            channel='Veritasium'
            image='https://i.ytimg.com/vi/fDek6cYijxI/hqdefault.jpg'
            />
            <VideoCard
            title="Marvel Studios' Thor: Love and Thunder | Official Trailer"
            views='6.1M views'
            timestamp='3 hours ago'
            channelImage='https://yt3.ggpht.com/fGvQjp1vAT1R4bAKTFLaSbdsfdYFDwAzVjeRVQeikH22bvHWsGULZdwIkpZXktcXZc5gFJuA3w=s68-c-k-c0x00ffffff-no-rj'
            channel='Marvel Entertainment'
            image='https://i.ytimg.com/vi/Go8nTmfrQd8/hqdefault.jpg?sqp=-oaymwEcCOADEI4CSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLB_Zp22Rb6L4nN--LXsMRR6kM0gKg'
            />
            <VideoCard
            title='Coke Studio | Season 14 | Pasoori | Ali Sethi x Shae Gill'
            views='139M views'
            timestamp='3 months ago'
            channelImage='https://yt3.ggpht.com/ytc/AKedOLTNtHgVmX114S4cnjoyFaDDJE6N1zNBwKgRNnYNAg=s68-c-k-c0x00ffffff-no-rj'
            channel='Coke Studio'
            image='https://i.ytimg.com/vi/5Eqb_-j3FDA/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLCmqHUqxnAhhIsNCS7l2xBvSY6ZXA'
            />
            <VideoCard
            title='The Secret, Incredible, and Inspiring Story of Khaby'
            views='3.6M views'
            timestamp='5 days ago'
            channelImage='https://yt3.ggpht.com/ytc/AKedOLQblZ0VMGBh7XodiihT4tXmrzaX6jJNAgBiJ4F1XA=s68-c-k-c0x00ffffff-no-rj'
            channel='Nas Daily'
            image='https://i.ytimg.com/vi/F26xVfZlj6E/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBbXVUVJoADl38_S2EKOIQtp29U9g'
            />
            <VideoCard
            title='Bali in 8k ULTRA HD HDR - Paradise of Asia (60 FPS)'
            views='4.3M views'
            timestamp='3 months ago'
            channelImage='image.png'
            channel='8K World'
            image='https://i.ytimg.com/vi/BFS9n4B_2xA/hqdefault.jpg?sqp=-oaymwEcCOADEI4CSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLD6HF5DWWrUxprLaY6XiSTlZi4rJA'
            />
            <VideoCard
            title='QUICK VEGAN BREAKFAST IDEAS » bento box style'
            views='7.8M views'
            timestamp='5 years ago'
            channelImage='https://yt3.ggpht.com/ytc/AKedOLQFII48R0atMndxGz1n5quE7W1VIpMvJxNnGlUYFg=s68-c-k-c0x00ffffff-no-rj'
            channel='Pick Up Limes'
            image='https://i.ytimg.com/vi/DtZ1EjV0EEw/maxresdefault.jpg'
            />
             <VideoCard
            title="Chaos: The Science of the Butterfly Effect"
            views='5.5M views'
            timestamp='2 years ago'
            channelImage='https://yt3.ggpht.com/ytc/AKedOLQYcLqrGZC1RZL4e1AFz5-ImMQmmgObvzWBCL7-mA=s68-c-k-c0x00ffffff-no-rj'
            channel='Veritasium'
            image='https://i.ytimg.com/vi/fDek6cYijxI/hqdefault.jpg'
            />

          
        </div>
    </div>
  )
}

export default RecommendedVideos